import React from "react";
import "./menu-providers.scss";
import { useTranslation } from "react-i18next";
import IconPik from "../../../mui/JSXIcons/IconPik";
import { useDispatch, useSelector } from "react-redux";
import ShowContainer from "../../../mui/ShowContainer";
import { Link, useParams } from "react-router-dom";
import { setOpenMenu } from "../../../../store/siteSlice";
import useGetLinkCallback from "../../../../hooks/other/useGetLinkCallback";

export default function MenuProviders() {
  const { t } = useTranslation();
  const { subId } = useParams();
  const dispatch = useDispatch();
  const providers = useSelector((state) => state.games.providers);
  const getLink = useGetLinkCallback();

  return (
    <ShowContainer condition={providers?.length}>
      <div className="menu__providers">
        <h2>
          <IconPik />
          {t("Casino games")}
        </h2>
        <div className="menu__providers__list">
          {providers.map((provider, indx) => {
            const isActive = subId === provider.name;
            const activeClass = isActive ? "active" : "";

            return (
              <Link
                to={getLink("/games/provider/" + provider.name)}
                onClick={() => dispatch(setOpenMenu(false))}
                className={`menu__providers__list__item ${activeClass}`}
                key={indx}>
                <img className="menu__providers__list__item__img" src={provider.logo} />
                <span className="menu__providers__list__item__title">{provider.name}</span>
                <div className="menu__providers__list__item__count">
                  <span>{provider.gameCount}</span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </ShowContainer>
  );
}
